/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase from '@/services/saleData';
import 'firebase/database';
import 'firebase/storage';
//import router from '@/router';
import _ from 'lodash';
export default {
  async fetchPromotions({commit}){
    const promotions = [];
    await firebase.firestore().collection('promotions').get().then((result)=>{
      result.forEach((doc)=>{
        const promotion = doc.data();
        promotion.id = doc.id;
        promotions.push(promotion);
      });
    });
    commit('SET_PROMOTIONS',promotions);
  },
  resetUser({commit}){
    commit('RESET_USER');
  },
  fetchUsers ({ commit }) {
    //const data = localStorage.getItem('userInfo');
    //const user = JSON.parse(data);
    /*if (user.company === undefined || user.company === '') {
      await firebase.auth().signOut().then(() => {
        router.push('/login').catch(() => {})
      });
    }*/
    firebase.database().ref().child('users').orderByChild('createdate').once('value', (snapshot) => {
      let users = []; 
      const userIds = [];
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        users.push(user)
        userIds[user.userId] = user.code;
      });
      users = _.orderBy(users, ['createdate'],['desc']);
      for(const x in users){
        if(users[x].userFriendId){
          users[x].userFriendCode = userIds[users[x].userFriendId];
        }else{
          users[x].userFriendCode = '';
        }
      }
      commit('SET_USERS', users);
    });
    //commit('SET_USERS', []);
  },
  fetchUser ({commit}, userId) {
    console.log(userId);
    return new Promise((resolve, reject) => {
      commit('SET_HISTORY', []);
      firebase.database().ref().child('users').orderByChild('userId').equalTo(userId).once('value', async (snapshot2) => {
        let userId = '';
        snapshot2.forEach((snapshot)=>{
          commit('SET_USER', snapshot.val());
          userId = snapshot.val().userId;
        });
        const rows = [];
        let dataTotal = 0;
        let withdrawTotal = 0;
        let depositTotal = 0;
        await firebase.firestore().collection('roulet').where('userId','==',userId).get().then((result)=>{
          result.forEach((doc)=>{
            rows.push({
              type:'รูเล็ต',
              createdate:doc.data().createdate,
              qty:doc.data().value,
            });
          });
        });
        await firebase.firestore().collection('sharefriend').where('userId','==',userId).get().then((result)=>{
          result.forEach((doc)=>{
            rows.push({
              type:'แนะนำเพื่อน 15%',
              createdate:doc.data().createdate,
              qty:doc.data().value,
            });
          });
        });
        await firebase.firestore().collection('waste').where('userId','==',userId).get().then((result)=>{
          result.forEach((doc)=>{
            rows.push({
              type:'คืนยอดเสีย',
              createdate:doc.data().createdate,
              qty:doc.data().waste,
            });
          });
        });
        await firebase.firestore().collection('redeemreward').where('userId','==',userId).get().then((result)=>{
          result.forEach((doc)=>{
            rows.push({
              type:'แลกเหรียญ',
              createdate:doc.data().createdate,
              qty:doc.data().credit,
            });
          });
        });
        await firebase.firestore().collection('history').where('status','==','ดำเนินการแล้ว').where('userId','==',userId).orderBy('createdate','desc').get().then((result)=>{
          result.forEach((doc)=>{
              const qty = (doc.data().type === 'ฝาก')?'-'+doc.data().qty:doc.data().qty;
              dataTotal += Number(qty.toString().replace(/,/g,''));
              rows.push(doc.data());
              if(doc.data().type === 'ถอน'){
                withdrawTotal += Number(qty.toString().replace(/,/g,''));
              }else{
                depositTotal += Number(qty.toString().replace(/,/g,''));
              }
          });
        });
        commit('SET_DEPOSIT_TOTAL', depositTotal);
        commit('SET_WITHDRAW_TOTAL', withdrawTotal);
        commit('SET_TOTAL', dataTotal);
        commit('SET_HISTORY', _.orderBy(rows, ['createdate'],['desc']));
        resolve();
      }).catch((error) => { reject(error) });
    })
  },
  fetchHistory({commit},{userId,startdate,enddate}){
    return new Promise((resolve, reject) => {
      commit('SET_HISTORY', []);
      firebase.database().ref().child('users').orderByChild('userId').equalTo(userId).once('value', (snapshot2) => {
        snapshot2.forEach((snapshot)=>{
          firebase.firestore().collection('history').where('status','==','ดำเนินการแล้ว').where('userId','==',snapshot.val().userId).where('createdate','>=',`${startdate} 00:00`).where('createdate','<=',`${enddate} 23:59`).orderBy('createdate','desc').get().then((result)=>{
            let depositTotal = 0;
            let withdrawTotal = 0;
            let dataTotal = 0;
            const data = [];
            result.forEach((doc)=>{
                const qty = (doc.data().type === 'ฝาก')?'-'+doc.data().qty:doc.data().qty;
                dataTotal += Number(qty.toString().replace(/,/g,''));
                data.push(doc.data());
                if(doc.data().type === 'ถอน'){
                  withdrawTotal += Number(qty.toString().replace(/,/g,''));
                }else{
                  depositTotal += Number(qty.toString().replace(/,/g,''));
                }
            });
            commit('SET_DEPOSIT_TOTAL', depositTotal);
            commit('SET_WITHDRAW_TOTAL', withdrawTotal);
            commit('SET_TOTAL', dataTotal);
            commit('SET_HISTORY', data);
          });
          resolve();
        });
      }).catch((error) => { reject(error) });
    })
  },
  updateUsers({state,commit}, {key,value}){
    console.log(key);
    console.log(value);
    console.log(state.users);
    const users = state.users;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      if(value.userFriendId){
        const keyUser2 = _.findKey(users, function(o) { return o.userId === value.userFriendId; });
        if(keyUser2 && users[keyUser2] && users[keyUser2].code){
          value.userFriendCode = users[keyUser2].code;
        }
      }else{
        value.userFriendCode = '';
      }
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_USERS', users);
    }
  },
  /*fetchUser ({commit}, userId) {
    const data = localStorage.getItem('userInfo');
    const user = JSON.parse(data);
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('users').orderByChild('company').equalTo(user.company).once('value', (snapshot) => {
        snapshot.forEach((arrData) => {
          if(arrData.val().code == userId){
            const user = arrData.val();
            if(user.avatar)
              user.avatar_path = user.avatar;
            user.edit = true;
            delete user.password;
            commit('SET_USER', user);
            resolve(user);
          } 
        });
      }).catch((error) => { reject(error) });
    })
    return new Promise((resolve, reject) => {
      axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },*/
  async updateFieldUsers({rootState},{key,value,column}) {
    if(key){
      console.log(rootState);
      if(column === 'account_no'){
        let checkbankno = '';
        if(value.toString().length == 10)
            checkbankno = value.toString().substring(3, value.toString().length);
        else
            checkbankno = value.toString().substring(5, value.toString().length);
        const scbcheck = value.toString().slice(-6);
        firebase.database().ref('users/'+key).update({
          account_no:value,
          account_no_check:checkbankno,
          account_no_check_scb:scbcheck,
        });
      }else{
        firebase.database().ref('users/'+key).update({
          [`${column}`]:value,
        });
      }
    }
  },
  getUsersOption({commit}){
    firebase.database().ref().child('users').orderByChild('calculate').equalTo('Y').once('value', (snapshot) => {
      const users = [];
      snapshot.forEach((arrData) => {
        users.push({
          code:arrData.val().code,
          userId:arrData.val().userId
        });
      });
      const _users = _.orderBy(users, ['code'],['asc']);
      commit('SET_USEROPTION', _users);
    })
  },
  getUsersOptionTrueWallet({commit}){
    firebase.database().ref().child('users').orderByChild('bank').equalTo('truewallet').once('value', (snapshot) => {
      const users = [];
      snapshot.forEach((arrData) => {
        users.push({
          code:arrData.val().code,
          userId:arrData.val().userId
        });
      });
      const _users = _.orderBy(users, ['code'],['asc']);
      commit('SET_USEROPTION_TRUEWALLET', _users);
    })
  },
  removeRecord (userId) {
    return new Promise(() => {
      firebase.database().ref('users/'+userId).remove();
    })
  }
}
